// Part-number helpers shared with the server so the browser and searchParts agree on what
// counts as the same number (dashes, spaces and case ignored).
import { splitPartNumbers, normalise } from '../../server/search.js';

export { splitPartNumbers };
export const normalisePN = normalise;

const NUMBER_COLUMNS = ['oem_pn', 'part_numbr', 'look_up_pn'];

/** Find the catalog part whose own part number is `number`, or null. */
export const findPartByNumber = (parts, number) =>
  parts.find((p) => NUMBER_COLUMNS.some((c) => splitPartNumbers(p[c]).some((pn) => normalise(pn) === normalise(number)))) || null;
